import React from 'react';
import PropTypes from 'prop-types';
import { Label, Panel } from 'react-bootstrap';

import ItemHeader from './project_card/item_header';

export default class ProjectCard extends React.Component {
  static propTypes = {
    bare: PropTypes.bool.isRequired,
    bodyObjects: PropTypes.arrayOf(PropTypes.node),
    children: PropTypes.node,
    className: PropTypes.string,
    name: PropTypes.string,
    pillLabelText: PropTypes.string,
    rightActions: PropTypes.arrayOf(PropTypes.node),
    rightActionText: PropTypes.node,
    wrapBody: PropTypes.bool.isRequired,
    onRightAction: PropTypes.func
  };

  static defaultProps = {
    bare: false,
    className: 'overview-panel',
    format: 'full',
    wrapBody: false
  }

  doRightAction = (e) => {
    e.preventDefault();
    this.props.onRightAction();
  }

  renderPillLabel() {
    if (this.props.pillLabelText) {
      return (
        <Label className="pill-label panel-header-label left-buffer-md text-muted text-uppercase" name="pill-label">
          {this.props.pillLabelText}
        </Label>
      );
    }
  }

  willRenderRightAction() {
    return this.props.rightActionText && this.props.onRightAction;
  }

  renderRightAction() {
    if (this.willRenderRightAction()) {
      return (
        <div className="text-right text-nowrap">
          <a className="btn-link pull-right text-nowrap" href="#" name="card-right-action" onClick={this.doRightAction}>
            <small>{this.props.rightActionText}</small>
          </a>
        </div>
      );
    }

    if (this.props.rightActions && this.props.rightActions.length > 0) {
      const actions = this.props.rightActions.map((node, i) => {
        const spanClass = i < this.props.rightActions.length - 1 ? 'align-middle mr-5' : 'align-middle';
        return (
          <span className={spanClass} key={i}>{node}</span>
        );
      });
      return (
        <div className="text-right">
          {actions}
        </div>
      );
    }
  }

  renderOneBodyObject(object, index) {
    const keyValue = object.key ? `object-${object.key}` : `key-${index}`;

    return (
      <li className="list-group-item project-card-row border-bottom" key={keyValue} name="taskRow">
        {object}
      </li>
    );
  }

  renderBodyObjects() {
    return (
      <ul className="list-group">
        {this.props.bodyObjects.map(this.renderOneBodyObject)}
      </ul>
    );
  }

  renderMainBody() {
    if (this.props.bodyObjects) {
      return this.renderBodyObjects();
    }

    return this.props.children;
  }

  renderBody() {
    if (this.props.wrapBody) {
      return <Panel.Body>{this.renderMainBody()}</Panel.Body>;
    } else {
      return this.renderMainBody();
    }
  }

  renderBareCard() {
    return (
      <React.Fragment>
        <Panel.Heading>
          <div className="row-eq-height">
            <div className="card-header grow">
              <span className="panel-title">
                {this.props.name}
              </span>
              {this.renderPillLabel()}
            </div>
            <div className="cta-links">
              {this.renderRightAction()}
            </div>
          </div>
        </Panel.Heading>
        {this.renderBody()}
      </React.Fragment>
    );
  }

  renderFullCard() {
    return (
      <Panel className={this.props.className}>
        {this.props.name ? this.renderBareCard() : this.renderBody()}
      </Panel>
    );
  }

  render() {
    if (this.props.bare) {
      return this.renderBareCard();
    } else {
      return this.renderFullCard();
    }
  }
}

ProjectCard.ItemHeader = ItemHeader;
